import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import TextFormEditor from "../../../component/atoms/input/textFormEditor";
import PretendardText from "../../../component/atoms/text/pretendardText";
import MainInput from "./../../../component/atoms/input/mainInput";
import BasicBtn from "./../../../component/atoms/button/basicBtn";
import Checkbox from "./../../../component/atoms/input/checkbox";
import SelectBoxValue from "../../../component/organisms/selectBoxValue";
import NoticeApi from "../../../api/notice.api";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import { errorHandler } from "../../../util/errorHandler";
import BoardApi from "../../../api/board.api";

const OperationNoticeCreate = () => {
  const navigate = useNavigate();

  // ---------- 제목 분류 관련 ---------- //
  const [noticeTypeBoxOpen, setNoticeTypeBoxOpen] = useState(false);
  const [selectedNoticeType, setSelectedNoticeType] = useState("");

  const noticeTypeList = [
    {
      title: "공지",
      value: "NOTICE",
    },
    {
      title: "필독",
      value: "MUST_READ",
    },
    {
      title: "알려드려요",
      value: "INFO",
    },
  ];

  // ---------- 카테고리 관련 ---------- //
  const [categoryBoxOpen, setCategoryBoxOpen] = useState(false);

  // ---------- 텍스트 에디터 관련 ---------- //
  const [title, setTitle] = useState("");
  const [noticeContent, setNoticeContent] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [categoryValue, setCategoryValue] = useState([]);

  // ---------- 상위 카테고리 관련 ---------- //
  const [mainCategoryList, setMainCategoryList] = useState([]);

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    getMainCategoryList();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // 상위 카테고리 가져오기
  const getMainCategoryList = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
        sort: "orderNumber",
        orderBy: "ASC",
      };

      const response = (await BoardApi.getListMain(data)).data.data.content;

      setMainCategoryList(response);

      // 상태 업데이트
    } catch (error) {
      errorHandler(error);
    }
  };

  const createFunc = async () => {
    try {
      if (selectedNoticeType === "") {
        return toast("타입을 선택해주세요.");
      }

      if (title === "") {
        return toast("제목을 입력해주세요.");
      }

      if (noticeContent === "") {
        return toast("상세 내용을 입력해주세요.");
      }

      if (categoryValue.length === 0) {
        return toast("카테고리를 선택해주세요.");
      }

      const data = {
        title: title,
        content: noticeContent,
        noticeCategoryTitle: categoryValue.map((item) => item.title).join(", "),
        noticeExcludeBoardTypeList: categoryValue
          .filter((item) => item.type === "excludeBoardType")
          .map((item) => item.value),
        noticeBoardCategoryIdList: categoryValue
          .filter((item) => item.type === "includeBoardType" && item.category)
          .map((item) => item.category),
        noticeBoardSubCategoryIdList: categoryValue
          .filter(
            (item) => item.type === "includeBoardType" && item.subCategory
          )
          .map((item) => item.subCategory),
        noticePostType: selectedNoticeType,
      };

      await NoticeApi.create(data);

      toast(toastMsg.create);
      navigate(-1);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>공지사항 편집 및 추가</TableTitle>
          <NoticeInputWrapper
            style={{
              padding: "21px 0px",
            }}
          >
            <NoticeInputTitle>제목</NoticeInputTitle>
            <SelectBoxValue
              isMiddle={true}
              placeholder="선택"
              selectedValue={selectedNoticeType}
              isOpen={noticeTypeBoxOpen}
              wrapperHandler={() => {
                setNoticeTypeBoxOpen(!noticeTypeBoxOpen);
              }}
              itemList={noticeTypeList}
              selectedValueSetterFunc={setSelectedNoticeType}
            />
            <MainInput
              type={"text"}
              placeholder={"내용을 입력해 주세요."}
              style={{
                width: "572px",
                marginLeft: "12px",
              }}
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
              }}
            />
          </NoticeInputWrapper>
          <NoticeInputWrapper
            style={{
              height: "fit-content",
              padding: "18px 0px",
              marginBottom: 24,
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                gap: 5,
              }}
              onClick={() => {
                setCategoryBoxOpen(!categoryBoxOpen);
              }}
            >
              <NoticeInputTitle
                style={{
                  width: "fit-content",
                }}
              >
                카테고리
              </NoticeInputTitle>
              <img
                className={categoryBoxOpen ? "rotate" : "rotate-back"}
                style={{
                  width: "18px",
                  height: "18px",
                }}
                src="/assets/admin/icons/ico_select_arrow_down.svg"
                alt="카테고리 펼치기"
              />
            </div>
            {categoryBoxOpen && (
              <>
                <CategoryDescriptionText>
                  지정한 카테고리 상단의 한줄 공지란에 출력되며 일반 게시물로로
                  추가됩니다 (다중 선택 가능)
                </CategoryDescriptionText>
                <CategorySelectBoxContainer>
                  {/* 홈 */}
                  <CategorySelectBoxWrapper>
                    <CategorySelectBoxTitle>홈</CategorySelectBoxTitle>
                    <CategorySelectBoxListWrapper>
                      <CheckboxWrapper
                        onClick={() => {
                          if (
                            categoryValue.some(
                              (cItem) => cItem.value === "MEMBER_HOME"
                            )
                          ) {
                            let temp = categoryValue.filter(
                              (cItem) => cItem.value !== "MEMBER_HOME"
                            );
                            setCategoryValue(temp);
                          } else {
                            setCategoryValue([
                              ...categoryValue,
                              {
                                title: "회원랜딩 홈",
                                value: "MEMBER_HOME",
                                type: "excludeBoardType",
                              },
                            ]);
                          }
                        }}
                      >
                        <Checkbox
                          checked={categoryValue.some(
                            (cItem) => cItem.value === "MEMBER_HOME"
                          )}
                          onChange={() => {}}
                        />
                        <CheckboxText>회원랜딩 홈</CheckboxText>
                      </CheckboxWrapper>
                    </CategorySelectBoxListWrapper>
                  </CategorySelectBoxWrapper>

                  {/* 일급비밀 */}
                  <CategorySelectBoxWrapper>
                    <CategorySelectBoxTitle>일급비밀</CategorySelectBoxTitle>
                    <CategorySelectBoxListWrapper>
                      <CheckboxWrapper
                        onClick={() => {
                          if (
                            categoryValue.some(
                              (cItem) => cItem.value === "SECRET_QNA"
                            )
                          ) {
                            let temp = categoryValue.filter(
                              (cItem) => cItem.value !== "SECRET_QNA"
                            );
                            setCategoryValue(temp);
                          } else {
                            setCategoryValue([
                              ...categoryValue,
                              {
                                title: "멤버십 QnA",
                                value: "SECRET_QNA",
                                type: "excludeBoardType",
                              },
                            ]);
                          }
                        }}
                      >
                        <Checkbox
                          checked={categoryValue.some(
                            (cItem) => cItem.value === "SECRET_QNA"
                          )}
                          onChange={() => {}}
                        />
                        <CheckboxText>멤버십 QnA</CheckboxText>
                      </CheckboxWrapper>
                    </CategorySelectBoxListWrapper>
                  </CategorySelectBoxWrapper>

                  {/* 커뮤니티 */}
                  <CategorySelectBoxWrapper>
                    <CategorySelectBoxTitle>커뮤니티</CategorySelectBoxTitle>

                    {mainCategoryList.length > 0
                      ? mainCategoryList.map((item, index) => {
                          if (item.id === 7) return null;

                          return (
                            <CategorySelectBoxListWrapper key={index}>
                              {item.boardSubCategoryList.length > 0 ? (
                                item.boardSubCategoryList.map(
                                  (item02, index02) => {
                                    return (
                                      <CheckboxWrapper
                                        key={index02}
                                        onClick={() => {
                                          if (
                                            categoryValue.some(
                                              (cItem) =>
                                                cItem.subCategory === item02.id
                                            )
                                          ) {
                                            let temp = categoryValue.filter(
                                              (cItem) =>
                                                cItem.subCategory !== item02.id
                                            );
                                            setCategoryValue(temp);
                                          } else {
                                            setCategoryValue([
                                              ...categoryValue,
                                              {
                                                title: item02.title,
                                                subCategory: item02.id,
                                                type: "includeBoardType",
                                              },
                                            ]);
                                          }
                                        }}
                                      >
                                        <Checkbox
                                          checked={categoryValue.some(
                                            (cItem) =>
                                              cItem.subCategory === item02.id
                                          )}
                                          onChange={() => {}}
                                        />
                                        <CheckboxText>
                                          {item02.title}
                                        </CheckboxText>
                                      </CheckboxWrapper>
                                    );
                                  }
                                )
                              ) : (
                                <CheckboxWrapper
                                  onClick={() => {
                                    if (item.id === 1) {
                                      if (
                                        categoryValue.some(
                                          (cItem) =>
                                            cItem.value === "COMMUNITY_HOME"
                                        )
                                      ) {
                                        let temp = categoryValue.filter(
                                          (cItem) =>
                                            cItem.value !== "COMMUNITY_HOME"
                                        );
                                        setCategoryValue(temp);
                                      } else {
                                        setCategoryValue([
                                          ...categoryValue,
                                          {
                                            title: "커뮤니티 홈",
                                            value: "COMMUNITY_HOME",
                                            type: "excludeBoardType",
                                          },
                                        ]);
                                      }
                                    } else {
                                      if (
                                        categoryValue.some(
                                          (cItem) => cItem.category === item.id
                                        )
                                      ) {
                                        let temp = categoryValue.filter(
                                          (cItem) => cItem.category !== item.id
                                        );
                                        setCategoryValue(temp);
                                      } else {
                                        setCategoryValue([
                                          ...categoryValue,
                                          {
                                            title: item.title,
                                            category: item.id,
                                            type: "includeBoardType",
                                          },
                                        ]);
                                      }
                                    }
                                  }}
                                >
                                  <Checkbox
                                    checked={
                                      item.id === 1
                                        ? categoryValue.some(
                                            (cItem) =>
                                              cItem.value === "COMMUNITY_HOME"
                                          )
                                        : categoryValue.some(
                                            (cItem) =>
                                              cItem.category === item.id
                                          )
                                    }
                                    onChange={() => {}}
                                  />
                                  <CheckboxText>{item.title}</CheckboxText>
                                </CheckboxWrapper>
                              )}
                            </CategorySelectBoxListWrapper>
                          );
                        })
                      : null}
                  </CategorySelectBoxWrapper>

                  {/* 크루전용 */}
                  <CategorySelectBoxWrapper
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CategorySelectBoxTitle>크루전용</CategorySelectBoxTitle>
                    <CategorySelectBoxListWrapper>
                      <CheckboxWrapper
                        onClick={() => {
                          if (
                            categoryValue.some(
                              (cItem) => cItem.value === "WRITING_LINK"
                            )
                          ) {
                            let temp = categoryValue.filter(
                              (cItem) => cItem.value !== "WRITING_LINK"
                            );
                            setCategoryValue(temp);
                          } else {
                            setCategoryValue([
                              ...categoryValue,
                              {
                                title: "라이팅링크",
                                value: "WRITING_LINK",
                                type: "excludeBoardType",
                              },
                            ]);
                          }
                        }}
                      >
                        <Checkbox
                          checked={categoryValue.some(
                            (cItem) => cItem.value === "WRITING_LINK"
                          )}
                          onChange={() => {}}
                        />
                        <CheckboxText>라이팅링크</CheckboxText>
                      </CheckboxWrapper>
                      <CheckboxWrapper
                        onClick={() => {
                          if (
                            categoryValue.some(
                              (cItem) => cItem.value === "ARCHIVE"
                            )
                          ) {
                            let temp = categoryValue.filter(
                              (cItem) => cItem.value !== "ARCHIVE"
                            );
                            setCategoryValue(temp);
                          } else {
                            setCategoryValue([
                              ...categoryValue,
                              {
                                title: "자료창고",
                                value: "ARCHIVE",
                                type: "excludeBoardType",
                              },
                            ]);
                          }
                        }}
                      >
                        <Checkbox
                          checked={categoryValue.some(
                            (cItem) => cItem.value === "ARCHIVE"
                          )}
                          onChange={() => {}}
                        />
                        <CheckboxText>자료창고</CheckboxText>
                      </CheckboxWrapper>
                    </CategorySelectBoxListWrapper>
                  </CategorySelectBoxWrapper>
                </CategorySelectBoxContainer>
              </>
            )}
          </NoticeInputWrapper>
          <TextFormEditor
            placeholder={"상세 내용을 입력해주세요"}
            value={noticeContent}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            onChange={(e) => {
              setNoticeContent(e);
            }}
            editorHeight={668}
            style={{
              width: "100%",
            }}
          />
          <div
            style={{
              width: "100%",
              height: 79,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            <BasicBtn
              onClick={() => {
                createFunc();
              }}
            >
              저장하기
            </BasicBtn>
          </div>
        </DetailPageLayout>
      </MainLayout>
    </>
  );
};

export default OperationNoticeCreate;

const NoticeInputWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: 90px;
  display: flex;
  align-items: center;
  border-bottom: 0.5px solid var(--outline1, rgba(255, 255, 255, 0.12));
`;

const NoticeInputTitle = styled(PretendardText).attrs((props) => {})`
  width: 105px;
  height: fit-content;
  font-weight: 600;
  font-size: 14px;
  line-height: 22.75px;
  color: #aaa;
`;

const CategoryDescriptionText = styled(PretendardText).attrs((props) => {})`
  width: 100%;
  height: fit-content;
  font-weight: 500;
  font-size: 13px;
  line-height: 18.75px;
  color: rgba(181, 181, 181, 0.5);
  margin: 8px 0px 19px 0px;
`;

const CategorySelectBoxContainer = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const CategorySelectBoxWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const CategorySelectBoxTitle = styled(PretendardText).attrs((props) => {})`
  width: 100%;
  height: fit-content;
  font-weight: 600;
  font-size: 13px;
  line-height: 20px;
  color: #aaa;
`;

const CategorySelectBoxListWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  align-items: center;
  gap: 20px;
`;

const CheckboxWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CheckboxText = styled(PretendardText).attrs((props) => {})`
  font-size: 15px;
  font-weight: 500;
  line-height: 21.5px;
  color: #aaa;
  cursor: pointer;
`;
